import React, { useState } from "react";
import Tag from "./Tag";

const NETWORKS = [
  { key: "all", label: "FBA and AWD" },
  { key: "FBA", label: "FBA only" },
  { key: "AWD", label: "AWD only" },
];

export default function InboundBoard({ data, highlight }) {
  const [network, setNetwork] = useState("all");
  const [issuesOnly, setIssuesOnly] = useState(false);

  const columns = data.columns.map((c) => ({
    ...c,
    items: c.items.filter((i) => (network === "all" || i.network === network) && (!issuesOnly || i.level)),
  }));

  return (
    <div>
      <p className="ia-lead">
        Every FBA and AWD shipment from plan to close. A red card needs action today; amber needs a look this week.
      </p>
      <div className="ia-toolbar">
        <div className="ia-chips" role="group" aria-label="Network">
          {NETWORKS.map((n) => (
            <button type="button" key={n.key} className="ia-chip" aria-pressed={network === n.key} onClick={() => setNetwork(n.key)}>
              {n.label}
            </button>
          ))}
        </div>
        <button type="button" className="ia-chip" aria-pressed={issuesOnly} onClick={() => setIssuesOnly((v) => !v)}>
          {issuesOnly ? "Show all" : "Show issues only"}
        </button>
      </div>
      <div
        className="ia-board"
        style={{
          maxHeight: "calc(100vh - 220px)",
          minHeight: "480px",
          overflowY: "auto",
          overflowX: "auto",
          paddingBottom: "8px",
        }}
      >
        {columns.map((col) => (
          <div className="ia-col" key={col.key} style={{ display: "flex", flexDirection: "column" }}>
            <h3
              className="ia-col__title"
              style={{
                position: "sticky",
                top: 0,
                zIndex: 10,
                backgroundColor: "var(--ia-bg, #ffffff)",
                margin: 0,
                padding: "8px 0 10px 0",
                borderBottom: "2px solid var(--ia-line, #e6e8eb)",
              }}
            >
              {col.title} <span className="ia-count">{col.items.length}</span>
            </h3>
            <div style={{ paddingTop: "10px" }}>
              {col.items.length === 0 ? <div className="ia-muted ia-col__empty">None</div> : null}
              {col.items.map((c) => (
                <div
                  key={c.id}
                  className={`ia-card ia-ship${c.level === "u" ? " ia-ship--urgent" : c.level === "s" ? " ia-ship--soon" : ""}${
                    highlight && (highlight === c.id || highlight === c.title) ? " ia-ship--highlight" : ""
                  }`}
                >
                  <div className="ia-ship__id">
                    {c.title}
                    {c.network === "AWD" ? <span className="ia-muted"> AWD</span> : null}
                  </div>
                  <div className="ia-ship__meta">{c.meta}</div>
                  <Tag level={c.tag.level}>{c.tag.label}</Tag>
                  {typeof c.progress === "number" ? (
                    <div className="ia-progress" title={`${c.progress}% received`}>
                      <i style={{ width: `${c.progress}%` }} />
                    </div>
                  ) : null}
                  {c.note ? <p className="ia-ship__note">{c.note}</p> : null}
                  {c.data && c.data.placement && c.data.placement.length > 1 ? (
                    <details className="ia-ship__more">
                      <summary>Placement options</summary>
                      <ul>
                        {c.data.placement.map((o) => (
                          <li key={o.id}>
                            {o.status.toLowerCase()}: {o.currency || "$"} {o.fee}
                          </li>
                        ))}
                      </ul>
                    </details>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
